<template>
    <div class="d-flex justify-center">
        <div class="w-100 checkboxes-wrapper">
            <div class="checkboxes-container p20 w-100 background-white">
                <input name="form_contact_name" type="hidden" v-model="form_contact_name" value=""> <!-- This is a honeypot for spam bots -->
                <div v-for="(contributionField,index) in contributionFields" v-bind:key="'key_'+index">
                    <input type="checkbox"
                           :id="'checkbox-'+contributionField.slug"
                           :value="contributionField.slug"
                           v-model="selected_checkboxes"
                           style="display:none">
                    <label :for="'checkbox-'+contributionField.slug"
                           class="d-inline-block" style="font-size: 16px">
                        {{ contributionField.name }}
                    </label>
                    <transition name="fade">
                        <input type="text"
                               :placeholder="translations.suggest_trans"
                               v-if="selected_checkboxes.includes(contributionField.slug) && contributionField.allow_suggestion"
                               class="form-control m-b-10"
                               v-model="contributionField.suggest">
                    </transition>

                    <transition name="fade">
                        <input type="text"
                               :placeholder="translations.provide_reason"
                               v-if="selected_checkboxes.includes(contributionField.slug)"
                               class="form-control m-b-10"
                               v-model="contributionField.reason">
                    </transition>

                    <transition name="fade">
                        <!-- Image Upload Section -->
                        <div class="special-file-input"
                             v-if="selected_checkboxes.includes(contributionField.slug) && contributionField.allow_media">
                            <label :for="'imageFile' + contributionField.slug" class="ui button">Choose File</label>
                            <input type="file" :id="'imageFile' + contributionField.slug" @change="event => handleFileChange(event, contributionField.slug)" style="display: none;">
                            <span>{{ fileNames[contributionField.slug] || 'No File Chosen' }}</span>
                        </div>
                    </transition>
                </div>

                <div class="text-center" v-if="auth_check !== '1' && selected_checkboxes.length">
                    <br>
                    <input type="text"
                           :placeholder="translations.email_placeholder"
                           class="form-control m-b-10"
                           :class="valid_email ? 'has-success' : 'has-warning' "
                           v-model="email">
                </div>

                <div class="mt-8">
                    <strong>{{ translations.contribute_terms }}</strong>
                    <input id="terms-and-conditions" type="checkbox"
                           v-model="terms_agreed"
                           style="display: none;">
                    <label for="terms-and-conditions" class="d-inline-block" style="font-size: 16px;">
                        <span v-html="translations.terms_and_conditions"></span>
                    </label>
                </div>

                <div class="mt-8">
                    <a :href="cancel_route" rel="nofollow" class="btn btn-link">
                        {{ translations.cancel_text }}
                    </a>
                    <button class="huge ui speisekarte button"
                            @click="send_report()"
                            :disabled="!selected_checkboxes.length || !terms_agreed || (auth_check !== '1' && !valid_email)">
                        {{ translations.submit_trans }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'translations_str',
        'fields_str',
        'model_id',
        'store_contribution_route',
        'auth_check',
        'cancel_route',
    ],

    data() {
        return {
            selected_checkboxes: [],
            contributionFields: [],
            email: '',
            valid_email: false,
            translations: {},
            fileNames: {},
            files: {},
            terms_agreed: true,
            form_contact_name: '',
        }
    },

    mounted() {
        this.translations = JSON.parse(this.translations_str);
        this.contributionFields = JSON.parse(this.fields_str);

        // if there is only one contribution field, select it by default
        if (this.contributionFields.length === 1) {
            this.selected_checkboxes.push(this.contributionFields[0].slug);
        }
    },

    watch: {
        email() {
            this.valid_email = this.validateEmail(this.email)
        }
    },

    methods: {
        validateEmail(string) {
            if (this.auth_check === '1') {
                return true;
            }

            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (string.length === 0) {
                return false;
            }
            return re.test(string);
        },

        send_report() {
            let formData = new FormData();

            // Append files to formData
            for (const [slug, file] of Object.entries(this.files)) {
                formData.append(`files[${slug}]`, file);
            }

            let VueInstance = this;

            if (VueInstance.selected_checkboxes.length === 0) {
                iziToast.show({
                    title: VueInstance.translations.select_before_send,
                    color: 'red'  // blue, red, green, yellow
                });
                return;
            }

            let contributionsArray = [];
            for (const contributionField of VueInstance.contributionFields) {
                if (VueInstance.selected_checkboxes.includes(contributionField.slug) &&
                    contributionField.allow_suggestion &&
                    (!contributionField.suggest || contributionField.suggest.trim() === "")) {
                    iziToast.show({
                        title: VueInstance.translations.fill_selected,
                        color: 'red'  // blue, red, green, yellow
                    });
                    return;
                }

                if (!VueInstance.selected_checkboxes.includes(contributionField.slug)) {
                    continue;
                }

                let itemCopy = { ...contributionField };
                contributionsArray.push(itemCopy);
            }

            formData.append('model_id', this.model_id);
            formData.append('email', this.email);
            formData.append('formContactName', this.form_contact_name);

            this.selected_checkboxes.forEach((checkbox, index) => {
                formData.append(`selected_checkboxes[${index}]`, checkbox);
            });

            let excludedContribKeys = ['name', 'pivot', 'translations', 'created_at', 'updated_at'];
            contributionsArray.forEach((contribution, index) => {
                for (let key in contribution) {
                    if (excludedContribKeys.includes(key)) {
                        continue;
                    }

                    formData.append(`contributions[${index}][${key}]`, contribution[key]);
                }
            });

            axios.post(
                VueInstance.store_contribution_route, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(function (response) {
                    if (response.data.redirectHome) {
                        window.location.href = '/';
                    }

                    VueInstance.selected_checkboxes = [];
                    VueInstance.contributionFields = VueInstance.contributionFields.map(function (contributionField) {
                        contributionField.suggest = null;
                        contributionField.reason = null;
                        return contributionField;
                    });

                    VueInstance.files = {};
                    VueInstance.fileNames = {};

                    VueInstance.terms_agreed = true;

                    iziToast.show({
                        title: response.data.message,
                        color: response.data.status
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        handleFileChange(event, slug) {
            const files = event.target.files;
            if (files.length > 0) {
                this.$set(this.files, slug, files[0]);
                this.$set(this.fileNames, slug, files[0].name);
            }
        },
    }
}
</script>

<style>
.d-inline-block {
    display: inline-block !important;
}

.m-b-10 {
    margin-bottom: 10px;
}

.checkboxes-wrapper {
    max-width: 400px;
}

.checkboxes-container {
    border: 1px solid #eee;
    box-shadow: 1px 1px 2px #b3afaf;
}

.checkboxes-container label {
    color: rgba(54, 54, 54, 0.6);
}

.ui.speisekarte.button {
    background-color: #739745;
    color: #FFFFFF;
    text-shadow: none;
    background-image: none;
    -webkit-box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
    box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}

.ui.speisekarte.button:hover {
    background-color: #3a4f26;
}

/* File upload styles below */
.special-file-input {
    border: 2px dashed #e9e9e9;
    line-height: 1;
    max-width: 100%;
    min-width: 50%;
    height: 150px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.special-file-input label {
    background-color: #739745;
    color: #FFFFFF;
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    text-shadow: none;
}

.special-file-input label:hover {
    background-color: #3a4f26;
}

.special-file-input span {
    margin-top: 8px;
}
/* File upload styles above */
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ContributionFields.vue